import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f293ef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav_wrapper"
}
const _hoisted_2 = { class: "nav_inner" }
const _hoisted_3 = { class: "nav_item_text" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import store from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const menu = computed(() => {
  return store.getters['userMenu/userMenu'];
});
const displayContents = computed(() => {
  return menu.value.displayContents;
});
const isSearchLockUser = computed(() => {
  return store.getters['userMenu/isSearchLockUser'];
});
const route = useRoute();
const navItems = computed(() => {
  return [
    { label: 'ホーム', iconClass: 'icon_home', name: 'f00' },
    { label: '求人検索', iconClass: 'icon_search', name: 'h00', isSearchLockUser: isSearchLockUser.value },
    { label: 'おすすめ', iconClass: 'icon_recommend', name: 'l00' },
    { label: '検討中', iconClass: 'icon_pending', name: 'i00' },
    { label: '応募中', iconClass: 'icon_active', name: 'j00' },
  ];
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(displayContents) === 6)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navItems), (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.name
            }, [
              (!item.isSearchLockUser)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: item.name },
                    class: _normalizeClass(["nav_item", { 'is-current': _unref(route).name === item.name }])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["nav_item_icon", item.iconClass])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})